
import { mapState } from 'vuex';
import SocialMediaType from '@/enums/SocialMediaType';

export default {
  i18nComponentKey: 'WidgetReviewsExternal.components.ExternalEmbeddedSocialMediaInfoSection',
  name: 'ExternalEmbeddedSocialMediaInfoSection',
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('facebook', ['loggedIn']),
    SocialMediaType: () => SocialMediaType
  },
  watch: {
    loggedIn() {
      setTimeout(() => window.FB.XFBML.parse(), 0);
    }
  },
  mounted() {
    window.FB?.XFBML.parse();
  }
};
